import React, { useMemo } from "react";
import GenericRuleLogTable from "./GenericRuleLogTable";
import useRuleLogs from "./useRuleLogs";
import { ensureRowIds, extractRows } from "./useRuleLogs";

const PrioritizationRuleLogTable = ({ refreshKey = 0, rows: externalRows, loading: externalLoading = false }) => {
  const hasExternalRows = Array.isArray(externalRows);
  const { rows: fetchedRows, loading: fetchedLoading } = useRuleLogs("prioritization", refreshKey, {
    enabled: !hasExternalRows,
    initialRows: externalRows || [],
  });

  const rows = useMemo(
    () => ensureRowIds(extractRows(hasExternalRows ? externalRows : fetchedRows), "prioritization"),
    [externalRows, fetchedRows, hasExternalRows]
  );
  const loading = hasExternalRows ? externalLoading : fetchedLoading;

  return <GenericRuleLogTable rows={rows} loading={loading} />;
};

export default PrioritizationRuleLogTable;
